import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 256 256"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("desc", null, "Magnifying Glass Plus Streamline Icon: https://streamlinehq.com", -1),
    _createElementVNode("path", { d: "M157.046 108.852c0 5.323-4.316 9.639-9.64 9.639h-28.915v28.916c0 7.42-8.032 12.057-14.458 8.347a9.64 9.64 0 0 1-4.82-8.347V118.49H70.297c-7.42 0-12.057-8.033-8.347-14.459a9.64 9.64 0 0 1 8.347-4.819h28.916V70.297c0-7.42 8.033-12.057 14.458-8.347a9.64 9.64 0 0 1 4.82 8.347v28.916h28.916c5.323 0 9.638 4.316 9.638 9.639m93.567 141.761c-3.765 3.77-9.874 3.77-13.639 0l-60.314-60.326C113.87 242.589 18.006 207.303 4.107 126.773S68.697-19.134 145.387 9.095c68.843 25.339 91.85 111.2 44.9 167.565l60.326 60.314c3.77 3.765 3.77 9.874 0 13.64M108.852 195.6c66.779 0 108.516-72.29 75.126-130.122s-116.863-57.832-150.252 0a86.75 86.75 0 0 0-11.622 43.374c.053 47.888 38.86 86.695 86.748 86.748" }, null, -1)
  ])))
}
export default { render: render }